// Old Wix URLs (ranked on Google) → matching new pages. Used by App.js and scripts/prerender-seo.js
export const LEGACY_REDIRECTS = {
  '/index': '/',
  '/will-be-back-soon': '/',
  '/2d-drafting-services': '/services',
  '/land-survey-cad-drafting-services': '/services/land-surveying',
  '/land-surveying-cad-drafting-service': '/services/land-surveying',
  '/surveying-drafting-services': '/survey-cad-outsourcing',
  '/alta-nsps-land-survey-drafting-services': '/services/land-surveying/alta-surveys',
  '/commercial-boundary-survey-drafting': '/services/land-surveying/boundary-surveys',
  '/mortgage-survey-drafting-services': '/services/land-surveying/mortgage-location-surveys',
  '/land-development-services': '/services/land-development',
  '/landdevelopmentservice-1': '/services/land-development',
  '/civil-cad-drafting-services': '/services/civil-engineering',
  '/civilcaddraftingservice-1': '/services/civil-engineering',
  '/cad-conversion-services': '/survey-data-conversion',
  '/cad-drafting-conversion-services': '/survey-data-conversion',
  '/architectural-design-services': '/services/architectural',
  '/architecturalcaddraftingservices-1': '/services/architectural',
  '/architectural-3d-modeling-services': '/services/3d-modeling/architectural-3d-modeling',
  '/architectural-rendering-services': '/services/3d-modeling/3d-visualization',
  '/3d-visualization': '/services/3d-modeling/3d-visualization',
  '/3d-visualization-services': '/services/3d-modeling/3d-visualization',
  '/bim-services': '/services/bim-services',
  '/architectural-bim-services': '/services/bim-services',
  '/structural-bim-services': '/services/bim-services',
  '/bim-coordination-services': '/services/bim-services/bim-coordination',
  '/scan-to-bim-services': '/services/bim-services/scan-to-bim',
  '/revit-family-creation-services': '/services/bim-services/revit-family-creation',
  '/services/bim': '/services/bim-services',
  '/services/civil': '/services/civil-engineering',
  '/services/engineering': '/services/engineering-designs',
  '/services/mechanical': '/services/mechanical-modeling',
  '/blog': '/about/blog',
  '/clients': '/portfolio',
  '/examples': '/portfolio',
  '/projects': '/portfolio',
  '/team': '/about/team',
  '/why-land-drafters': '/about/why-us',
  '/hire-a-resource': '/get-started',
  '/contact-us': '/contact',
  '/about': '/about-us',
  '/copy-of-about-us': '/about-us',
  '/why-us': '/about/why-us',
  '/whyus': '/about/why-us',
  '/land-drafter-llc': '/',
  '/land-drafters-cad-drafting-services': '/services',
  '/land-surveying-drafting': '/services/land-surveying',
  '/land-surveying-cad-drafting': '/services/land-surveying',
  '/landsurveyingdrafting-1': '/services/land-surveying',
  '/copy-of-land-surveying-drafting': '/services/land-surveying',
  '/copy-of-land-development-service': '/services/land-development',
  '/architectural-cad-drafting-services': '/services/architectural',
  '/copy-of-architectural-cad-drafting--1': '/services/architectural',
  '/copy-of-architectural-cad-drafting-': '/services/civil-engineering',
  '/cad-conversion': '/survey-data-conversion',
  '/cad-conversion-1': '/survey-data-conversion',
  '/copy-of-3d-visualization': '/survey-data-conversion',
  '/3dvisualization-1': '/services/3d-modeling/3d-visualization',
  '/blog/design-a-stunning-blog': '/about/blog',
  '/blog/grow-your-blog-community': '/about/blog',
  '/blog/manage-your-blog-from-your-live-site': '/about/blog',
  '/post/design-a-stunning-blog': '/about/blog',
  '/post/grow-your-blog-community': '/about/blog',
  '/post/manage-your-blog-from-your-live-site': '/about/blog',
  '/thank-you': '/contact',
};

const LANG_PREFIX = /^\/(es|fr|ru|de)(?=\/|$)/;

// Returns the new path for an old URL, or null when it isn't a legacy URL
export const legacyTarget = (pathname, knownPaths) => {
  const p = (pathname.replace(/\/+$/, '') || '/').toLowerCase();
  if (LEGACY_REDIRECTS[p]) return LEGACY_REDIRECTS[p];
  if (p.startsWith('/blog/')) return '/about/blog';
  if (LANG_PREFIX.test(p)) {
    const en = p.replace(LANG_PREFIX, '') || '/';
    return LEGACY_REDIRECTS[en] || (knownPaths && !knownPaths.has(en) ? '/' : en);
  }
  return null;
};
